import { observer } from 'mobx-react-lite'
import Modals from 'singletons/Modals'
import Loading from '@ui-components-3/ui/lib/components/Loading'

import { useEffect } from 'react'

type ImagesContentProps = {
  // TODO - improve visit type
  visit: any
}

const ImagesContent = ({ visit }: ImagesContentProps) => {
  const { images } = visit || {}

  useEffect(() => {
    if (images?.isFetched) {
      images?.fetchThumbImages()
    }
  }, [images])

  const handleImageClick = async (imageId) => {
    Modals.open('photosImage', { imageId, images })
  }

  if (images?.isFetched && !images?.list?.length) return <p className="typography-body-l">There are no photos yet</p>
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 2xl:grid-cols-5 gap-3 lg:gap-6">
      {images.list.map(({ imageId }) => {
        const thumbSrc = images.getThumbSrc(imageId)
        return (
          <div key={imageId} className="flex items-center justify-center" onClick={() => handleImageClick(imageId)}>
            {thumbSrc ? <img src={thumbSrc} className="block w-full h-auto" /> : <Loading />}
          </div>
        )
      })}
    </div>
  )
}

export default observer(ImagesContent)
